import validate from "/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_auth_46global from "/src/clients/ckauth/src/runtime/middleware/01_auth.global.ts";
import access_45global from "/src/clients/ckclient/app/middleware/access.global.ts";
import manifest_45route_45rule from "/src/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_auth_46global,
  access_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}